import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Alat Berat',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Alat Berat',
        href: '/adm/logistic/alat-berat',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'code',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'jenis',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'no_kendaraan',
        label: 'No Kendaraan',
      },
      {
        key: 'merk',
        label: 'Merk',
      },
      {
        key: 'plat_no',
        label: 'Plat No',
      },
      {
        key: 'tahun',
        label: 'Tahun',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose_alatberat: [
      {
        key: 'code',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'jenis',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'no_kendaraan',
        label: 'No Kendaraan',
      },
      {
        key: 'merk',
        label: 'Merk',
      },
      {
        key: 'plat_no',
        label: 'Plat No',
      },
      {
        key: 'tahun',
        label: 'Tahun',
      },
    ],
    detail: false,
    form: {
      no_kendaraan: '',
      jenis: '',
      merk: '',
      plat_no: '',
      tahun: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeAlatBerat(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchAlatBerat(context, params = null) {
    let result = await ApiGetRequest(`logistic/alat-berat`, params);
    return !result.error ? result.data.object : [];
  },

  async getListAlatBerat({ commit, state }) {
    commit('changeAlatBerat', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`logistic/alat-berat`, params);
    commit('changeAlatBerat', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailAlatBerat({ commit, state }, payload = null) {
    commit('changeAlatBerat', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/alat-berat/${payload.id}`);
    commit('changeAlatBerat', {
      loading: false,
      detail: result.error ? false : result.data.object,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async importData({ commit, state, dispatch }) {
    commit('changeAlatBerat', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`logistic/alat-berat/import`, {
      items: data.import_form,
    });
    commit('changeAlatBerat', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createAlatBerat({ commit, state, dispatch }) {
    commit('changeAlatBerat', {
      loading: true,
    });

    let result = await ApiPostRequest(`logistic/alat-berat`, state.data.form);
    commit('changeAlatBerat', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateAlatBerat({ commit, state, dispatch }, payload = null) {
    commit('changeAlatBerat', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `logistic/alat-berat/${payload.id}`,
      state.data.form
    );

    commit('changeAlatBerat', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteAlatBerat({ commit, dispatch }, payload = null) {
    commit('changeAlatBerat', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`logistic/alat-berat/${payload.id}`);
    commit('changeAlatBerat', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
